import React, { useState } from 'react';
import Sidebar from '../Sidebar/Sidebar';
import Topbar from '../Topbar/Topbar';
import styles from './DashboardLayout.module.css';

/**
 * DashboardLayout — coque commune (sidebar + topbar + zone main).
 *
 * Props :
 *  - bento (default true) : applique la grille 12 colonnes (pour DashboardV2).
 *                           Passer `false` pour les Tabs au layout libre.
 *  - sidebarProps : { restaurant, user, onSwitchRestaurant, onLogout }
 *  - topbarProps  : { greeting, subtitle, selectedMonth, onMonthChange, onCtaClick, ... }
 */
export default function DashboardLayout({
  sidebarProps = {},
  topbarProps = {},
  bento = true,
  children,
}) {
  // État de la sidebar mobile (cachée par défaut sur < 720px)
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const openSidebar  = () => setSidebarOpen(true);
  const closeSidebar = () => setSidebarOpen(false);

  return (
    <>
      <Sidebar
        {...sidebarProps}
        isOpen={sidebarOpen}
        onClose={closeSidebar}
      />
      <main className={styles.main}>
        <Topbar
          {...topbarProps}
          onMenuClick={openSidebar}
        />
        {bento ? (
          <div className={styles.bento}>{children}</div>
        ) : (
          <div className={styles.tabContent}>{children}</div>
        )}
      </main>
    </>
  );
}
